import React from "react";

const CrossBrowsePanel = ({ summary, pairs, loading }) => {
  if (loading) {
    return (
      <div className="animate-pulse space-y-3">
        <div className="h-8 bg-gray-200 dark:bg-gray-800 rounded w-1/2" />
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-6 bg-gray-200 dark:bg-gray-800 rounded" />
        ))}
      </div>
    );
  }

  if (!pairs?.length) {
    return (
      <div className="text-center py-6 text-gray-500 dark:text-gray-400 text-sm">
        No cross-browse data for this period.
      </div>
    );
  }

  return (
    <div>
      {/* KPI callout */}
      {summary && (
        <div className="mb-4 pb-3 border-b border-gray-200 dark:border-gray-700">
          <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">{summary.multi_browse_pct}%</div>
          <div className="text-sm text-gray-500 dark:text-gray-400">of sessions browse 2+ site types</div>
        </div>
      )}

      {/* Ranked list */}
      <div className="space-y-1.5">
        <div className="hidden min-[500px]:flex items-center gap-3 text-sm uppercase tracking-wider font-semibold text-gray-400 dark:text-gray-500">
          <span className="flex-1">Pair</span>
          <span className="w-14 text-right shrink-0">Sess</span>
          <span className="w-10 text-right shrink-0">Bkd</span>
          <span className="w-12 text-right shrink-0">Conv</span>
        </div>
        {pairs.map((p, i) => (
          <div
            key={i}
            className={`flex flex-wrap items-center gap-3 gap-y-1 py-1.5 hover:bg-gray-50 dark:hover:bg-gray-800/30 rounded px-1 -mx-1 transition-colors max-[499px]:rounded-md max-[499px]:px-2 max-[499px]:py-2 max-[499px]:mx-0 ${i % 2 === 0 ? "max-[499px]:bg-gray-50 dark:max-[499px]:bg-gray-800/40" : ""}`}
            title={`${p.type_a} ↔ ${p.type_b}\n${p.sessions} sessions compared these types\n${p.booked} booked (${p.conversion_pct}%)${p.avg_value ? `\n$${p.avg_value} avg cart value` : ""}`}
          >
            <div className="flex-1 min-w-0 max-[499px]:basis-full">
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300 truncate block max-[499px]:whitespace-normal">
                <span className="hidden max-[499px]:inline text-gray-400 dark:text-gray-500 uppercase text-xs font-semibold tracking-wider mr-1">Pair</span>
                {p.type_a} <span className="text-gray-400 dark:text-gray-500 mx-0.5">↔</span> {p.type_b}
              </span>
            </div>
            <span className="text-sm text-gray-500 dark:text-gray-400 w-14 text-right shrink-0 max-[499px]:w-auto">
              <span className="hidden max-[499px]:inline text-gray-400 dark:text-gray-500 uppercase text-xs font-semibold tracking-wider mr-1">Sess</span>
              {p.sessions}
            </span>
            <span className="text-sm text-gray-500 dark:text-gray-400 w-10 text-right shrink-0 max-[499px]:w-auto">
              <span className="hidden max-[499px]:inline text-gray-400 dark:text-gray-500 uppercase text-xs font-semibold tracking-wider mr-1">Bkd</span>
              {p.booked}
            </span>
            <span className={`text-sm font-semibold w-12 text-right shrink-0 max-[499px]:w-auto ${
              p.conversion_pct > 5 ? "text-emerald-600 dark:text-emerald-400" : "text-gray-500 dark:text-gray-400"
            }`}>
              <span className="hidden max-[499px]:inline text-gray-400 dark:text-gray-500 uppercase text-xs font-semibold tracking-wider mr-1">Conv</span>
              {p.conversion_pct}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CrossBrowsePanel;
